import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_TAGS_API_PATHS } from '../constants/tags-api-paths.constants';

type UseDeleteTagResult = {
  isSubmitting: boolean;
  deleteTag: (tagId: string) => Promise<boolean>;
};

export function useDeleteTag(): UseDeleteTagResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deleteTag = async (tagId: string): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.delete<void>(ADMIN_TAGS_API_PATHS.DELETE_TAG(tagId));

      enqueueSnackbar('Le tag a été supprimé', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la suppression du tag'),
        {
          variant: 'error',
        }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, deleteTag };
}
